import { useState, useEffect, useCallback, useRef } from 'react';
import { notificationService } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export const useNotifications = () => {
  const { userProfile } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const intervalRef = useRef(null);

  const fetchUnreadCount = useCallback(async () => {
    if (!userProfile) return;
    try {
      const data = await notificationService.getUnreadCount();
      setUnreadCount(data.unread_count);
    } catch (e) { /* silent */ }
  }, [userProfile]);

  const fetchNotifications = useCallback(async (page = 1) => {
    if (!userProfile) return;
    setLoading(true);
    try {
      const data = await notificationService.getAll(page);
      if (page === 1) setNotifications(data.notifications);
      else setNotifications(prev => [...prev, ...data.notifications]);
      return data.pagination;
    } catch (e) { return null; }
    finally { setLoading(false); }
  }, [userProfile]);

  const markAsRead = useCallback(async (ids) => {
    if (!ids.length) return;
    try {
      await notificationService.markRead(ids);
      setNotifications(prev => prev.map(n => ids.includes(n.id) ? { ...n, is_read: true } : n));
      setUnreadCount(prev => Math.max(0, prev - ids.length));
    } catch (e) { /* silent */ }
  }, []);

  useEffect(() => {
    if (!userProfile) return;
    fetchUnreadCount();
    intervalRef.current = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(intervalRef.current);
  }, [userProfile, fetchUnreadCount]);

  return { unreadCount, notifications, loading, fetchNotifications, markAsRead, fetchUnreadCount };
};
